<template>
    <div id="banner">
        <b-container fluid>
            <b-row>
                <b-col class="centerv" style="position: relative;" lg="6">
                    <h1 v-html="$t('banner.title')"></h1>
                    <p>{{ $t('banner.subtitle') }}</p>
                    <span class="highlight">01 <div class="after"></div></span>
                </b-col>
                <b-col class="centerv" lg="6">
                    <img class="img-fluid" src="../assets/img_intro_form.png" alt="">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
#banner{
    padding-top: 150px;
    padding-left: 115px;
    padding-right: 115px;
}
h1{
    font-weight: 500 !important;
    font-size: 75px;
    text-transform: uppercase;
    line-height: 1;
}
p{
    font-weight: 300;
    font-size: 20px;
    max-width: 70%;
}
.highlight{
    display: inline-flex;
    transform: rotate(-90deg);
    position: absolute;
    bottom: -100px;
    left: 0;
}
.highlight .after{
    background: #DBBD6E;
    height: 1px;
    width: 50px;
    align-self: center;
    margin-left: 10px;
}

@media (max-width: 1200px){
    h1{
        font-size: 65px;
    }
}

@media (max-width: 992px){
    .highlight{
        display: none;
    }
}
@media (max-width: 768px){
    #banner{
        padding-top: 100px;
        padding-left: 25px;
        padding-right: 25px;
    }
    h1{
        font-size: 50px;
    }
}
</style>